module.exports = __webpack_public_path__ + "static/img/3_01.f2992344.png";